import { MainLayout } from 'shared/ui/layout/main';

import { Tabs } from '../tabs';

export function OwnersLayout() {
  return <MainLayout tabs={<Tabs />} />;
}
